
export const REPLACE_ITEMS_AND_GROUPS_DATA = 'REPLACE_ITEMS_AND_GROUPS_DATA';
export type REPLACE_ITEMS_AND_GROUPS_DATA = typeof REPLACE_ITEMS_AND_GROUPS_DATA;

export const REPLACE_ITEMS_DATA = 'REPLACE_ITEMS_DATA';
export type REPLACE_ITEMS_DATA = typeof REPLACE_ITEMS_DATA;

export const REPLACE_GROUPS_DATA = 'REPLACE_GROUPS_DATA';
export type REPLACE_GROUPS_DATA = typeof REPLACE_GROUPS_DATA;

export const REPLACE_INFO_PANEL_EDIT_MODE = 'REPLACE_INFO_PANEL_EDIT_MODE';
export type REPLACE_INFO_PANEL_EDIT_MODE = typeof REPLACE_INFO_PANEL_EDIT_MODE;

export const REPLACE_EXPANDED_NODES = 'REPLACE_EXPANDED_NODES';
export type REPLACE_EXPANDED_NODES = typeof REPLACE_EXPANDED_NODES;

export const REPLACE_CHECKED_NODES = 'REPLACE_CHECKED_NODES';
export type REPLACE_CHECKED_NODES = typeof REPLACE_CHECKED_NODES;

export const REPLACE_SELECTED_NODE = 'REPLACE_SELECTED_NODE';
export type REPLACE_SELECTED_NODE = typeof REPLACE_SELECTED_NODE;

export const REPLACE_SEARCH_DATA = 'REPLACE_SEARCH_DATA';
export type REPLACE_SEARCH_DATA = typeof REPLACE_SEARCH_DATA;

export const REPLACE_NODE_DATA = 'REPLACE_NODE_DATA';
export type REPLACE_NODE_DATA = typeof REPLACE_NODE_DATA;

export const REPLACE_NODE_INFO_DATA = 'REPLACE_NODE_INFO_DATA';
export type REPLACE_NODE_INFO_DATA = typeof REPLACE_NODE_INFO_DATA;

export const REPLACE_NODE_EDIT_DATA = 'REPLACE_NODE_EDIT_DATA';
export type REPLACE_NODE_EDIT_DATA = typeof REPLACE_NODE_EDIT_DATA;

export const REPLACE_TREE_VIEW_TYPE = 'REPLACE_TREE_VIEW_TYPE';
export type REPLACE_TREE_VIEW_TYPE = typeof REPLACE_TREE_VIEW_TYPE;

export const REPLACE_CHILD_GROUPS_IDS = 'REPLACE_CHILD_GROUPS_IDS';
export type REPLACE_CHILD_GROUPS_IDS = typeof REPLACE_CHILD_GROUPS_IDS;

export const REPLACE_CHILD_ITEMS_IDS = 'REPLACE_CHILD_ITEMS_IDS';
export type REPLACE_CHILD_ITEMS_IDS = typeof REPLACE_CHILD_ITEMS_IDS;

export const REPLACE_ALL_IDS = 'REPLACE_ALL_IDS';
export type REPLACE_ALL_IDS = typeof REPLACE_ALL_IDS;

export const REPLACE_FETCHING = 'REPLACE_FETCHING';
export type REPLACE_FETCHING = typeof REPLACE_FETCHING;

export const REPLACE_INFO_PANEL_FETCHING = 'REPLACE_INFO_PANEL_FETCHING';
export type REPLACE_INFO_PANEL_FETCHING = typeof REPLACE_INFO_PANEL_FETCHING;

export const REPLACE_INFO_PANEL_OPTIMIZE_MODE = 'REPLACE_INFO_PANEL_OPTIMIZE_MODE';
export type REPLACE_INFO_PANEL_OPTIMIZE_MODE = typeof REPLACE_INFO_PANEL_OPTIMIZE_MODE;

export const REPLACE_OPTIMIZE_DATA = 'REPLACE_OPTIMIZE_DATA';
export type REPLACE_OPTIMIZE_DATA = typeof REPLACE_OPTIMIZE_DATA;

export const REPLACE_OPTIMIZE_MIN_DISTANCE_BETWEEN_POINTS = 'REPLACE_OPTIMIZE_MIN_DISTANCE_BETWEEN_POINTS';
export type REPLACE_OPTIMIZE_MIN_DISTANCE_BETWEEN_POINTS = typeof REPLACE_OPTIMIZE_MIN_DISTANCE_BETWEEN_POINTS;

export const REPLACE_OPTIMIZE_ALLOWED_DEVIATION_FROM_LINE = 'REPLACE_OPTIMIZE_ALLOWED_DEVIATION_FROM_LINE';
export type REPLACE_OPTIMIZE_ALLOWED_DEVIATION_FROM_LINE = typeof REPLACE_OPTIMIZE_ALLOWED_DEVIATION_FROM_LINE;

export const CLOSE_OPTIMIZE_EDIT_MODE = 'CLOSE_OPTIMIZE_EDIT_MODE';
export type CLOSE_OPTIMIZE_EDIT_MODE = typeof CLOSE_OPTIMIZE_EDIT_MODE;

export const REPLACE_EDIT_HAS_CHANGED = 'REPLACE_EDIT_HAS_CHANGED';
export type REPLACE_EDIT_HAS_CHANGED = typeof REPLACE_EDIT_HAS_CHANGED;

export const REPLACE_NEW_AREA = 'REPLACE_NEW_AREA';
export type REPLACE_NEW_AREA = typeof REPLACE_NEW_AREA;

export const REPLACE_OPTIMIZE_FETCHING = 'REPLACE_OPTIMIZE_FETCHING';
export type REPLACE_OPTIMIZE_FETCHING = typeof REPLACE_OPTIMIZE_FETCHING;
